/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ContentZoneContext } from "cms/components/context";
import { isEmpty } from "lodash";
import { Fragment, useContext } from "react";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayNotEmpty } from "utils/empty-exists";
import { CardsSimpleItemDisplay } from "./cards-simple-item";

const CardsSimpleComponentDisplay = () => {

    const ctx = useContext(ContentZoneContext);
    const { component } = ctx || {};
    const { card_list } = component || {};
    const hasContent = !isEmpty(card_list);

    return (
        <Fragment>
            <EmptyContentMessage hasContent={hasContent} component={component} />
            {hasContent && (
                <Fragment>
                    <div className='cards-content'>
                        {isArrayNotEmpty(card_list) &&
                            card_list.map((item, index) => (
                                <CardsSimpleItemDisplay
                                    key={index}
                                    item={item}
                                />
                            ))
                        }
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

CardsSimpleComponentDisplay.displayName = "CardsSimpleComponentDisplay";
export { CardsSimpleComponentDisplay };
